import { AfterContentInit, Directive, ElementRef, EventEmitter, HostBinding, HostListener, inject, Input, Output } from '@angular/core';

@Directive({
  selector: '[appBottomSwipeSheet]',
})
export class BottomSwipeSheetDirective implements AfterContentInit {
  private bottomSwipeSheet = inject(ElementRef);

  private touchStartPoint: number;
  private currentPoint: number;
  private modalWidth: number;
  private modalHeight: number;
  private isTrueDirection: boolean = true;
  private axis: 'X' | 'Y';
  private isUpOrLeft: 1 | -1;
  private modalBodyScrollTop: number;
  private modalBodyScrollLeft: number;

  @HostBinding('style.transform') transform: string;
  @HostBinding('style.transition') transition: string;

  @Input() direction: 'up' | 'down' | 'left' | 'right' = 'down';
  @Input() threshold: number = 28;

  @Output() swipeAnimationEnd: EventEmitter<any> = new EventEmitter();
  @Output() swipeOpacity: EventEmitter<number> = new EventEmitter();

  ngAfterContentInit(): void {
    this.axis = this.getAxis(this.direction);
    this.isUpOrLeft = ['up', 'left'].includes(this.direction) ? -1 : 1;
    this.currentPoint = 0;
    this.modalBodyScrollTop = 0;
    this.modalBodyScrollLeft = 0;

    setTimeout(() => {
      this.modalWidth = this.bottomSwipeSheet.nativeElement.offsetWidth;
      this.modalHeight = this.bottomSwipeSheet.nativeElement.offsetHeight;
    }, 300);
  }

  @HostListener('touchstart', ['$event']) touchStart(event: TouchEvent): void {
    this.touchStartPoint = event.touches[0][`client${this.axis}`];
    this.modalBodyScrollTop = this.bottomSwipeSheet.nativeElement.querySelector('.modal__body.l-wrapper')?.scrollTop ?? 0;
    this.modalBodyScrollLeft = this.bottomSwipeSheet.nativeElement.querySelector('.modal__body.l-wrapper')?.scrollLeft ?? 0;
  }

  @HostListener('touchmove', ['$event']) touchMove(event: TouchEvent): void {
    const modalPoint = event.touches[0][`client${this.axis}`];
    const diff = modalPoint - this.touchStartPoint;
    this.isTrueDirection = this.isUpOrLeft * diff > 0;

    this.currentPoint = diff - (this.axis === 'Y' ? this.modalBodyScrollTop : this.modalBodyScrollLeft);

    if(this.isTrueDirection && this.isUpOrLeft * this.currentPoint > 0) {
      this.transform = `translate${this.axis}(${this.currentPoint}px)`;
      this.transition = 'none 0s ease 0s';

      const overlayOpacity = (100 - (this.currentPoint * 100 / this.modalHeight)) / 100;
      this.swipeOpacity.emit(overlayOpacity);
    }
  }

  @HostListener('touchend', ['$event']) touchEnd(): void {
    if(this.isTrueDirection && this.isUpOrLeft * this.currentPoint > this.threshold) {
      this.swipeModal();
      return;
    }

    this.resetPosition();
  }

  private resetPosition(): void {
    this.currentPoint = 0;
    this.modalBodyScrollTop = 0;
    this.modalBodyScrollLeft = 0;

    this.transform = `translate${this.axis}(${this.currentPoint}px)`;
    this.transition = '.18s ease transform';
  }

  swipeModal(direction?: 'up' | 'down' | 'left' | 'right'): void {
    this.transition = '.3s ease transform';

    direction = direction || this.direction;
    const axis = this.getAxis(direction);

    switch(direction) {
      case 'up':
        this.transform = `translate${axis}(-${this.modalHeight}px)`;
        break;
      case 'down':
        this.transform = `translate${axis}(${this.modalHeight}px)`;
        break;
      case 'left':
        this.transform = `translate${axis}(-${this.modalWidth}px)`;
        break;
      case 'right':
        this.transform = `translate${axis}(${this.modalWidth}px)`;
        break;
    }

    setTimeout(() => {
      this.swipeAnimationEnd.emit();
    }, 150);
  }

  private getAxis(direction: 'up' | 'down' | 'left' | 'right'): 'X' | 'Y' {
    return ['up', 'down'].includes(direction) ? 'Y' : 'X';
  }
}
